export default __webpack_public_path__ + "images/ce90331df3fe6eb571ea0b196488b8fc-lacross.jpg";